import { Box } from '@interstate/components/Box';

import { useDealSummary } from '../../../common/DealSummaryProvider';
import Trades from './Trades';

const TradesWrapper = () => {
    const { showDetailedView } = useDealSummary();

    if (showDetailedView) {
        return <Trades />;
    }

    return (
        <Box mt={1} ml={-1}>
            <Trades />
        </Box>
    );
};

export default TradesWrapper;
